import { render } from "./Changelogs.vue?vue&type=template&id=0948557a&scoped=true"
import script from "./Changelogs.vue?vue&type=script&lang=js"
export * from "./Changelogs.vue?vue&type=script&lang=js"

import "./Changelogs.vue?vue&type=style&index=0&id=0948557a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0948557a"]])

export default __exports__